import React from "react";

function ControlsStatesUsers({ audioMuted }) {
 
  return (
    <div className="controls">
      <div
        className={
          !audioMuted ? "controls-menu-status-users" : "off-status-users"
        }
      >
        <img
          src={
            !audioMuted
              ? `${process.env.REACT_APP_CONTACT_IMG}/mic.svg`
              : `${process.env.REACT_APP_CONTACT_IMG}/mic-off.svg`
          }
          width={30}
        ></img>
      </div>
    </div>
  );
}

export default ControlsStatesUsers;
